import React, { useState, useEffect } from 'react';
import { Spin, Alert, Card } from 'antd';
import UserRatingDetailView from './UserRatingDetailView';

const UserRatingPage = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('🔍 UserRatingPage mounted!');
    
    const getUserFromLocalStorage = () => {
      try {
        // Try sessionData first (based on your AppHeader)
        let userStr = localStorage.getItem('sessionData');
        console.log('📦 sessionData from localStorage:', userStr);
        
        // If sessionData doesn't exist, try 'user'
        if (!userStr) {
          userStr = localStorage.getItem('user');
          console.log('📦 user from localStorage:', userStr);
        }
        
        if (!userStr) {
          console.error('❌ No user data found in localStorage');
          setError('No user found in localStorage. Please login again.');
          setLoading(false);
          return;
        }

        const userData = JSON.parse(userStr);
        console.log('✅ Parsed user data:', userData);
        
        // Validate userId exists
        if (!userData.userId) {
          console.error('❌ userId not found in user data');
          setError('User ID not found. Please login again.');
          setLoading(false);
          return;
        }

        console.log('✅ Creating user object with ID:', userData.userId);
        
        // Set user object with the structure expected by UserRatingDetailView
        const userObject = {
          id: userData.userId,
          name: userData.name || 'User',
          role: userData.accountRole || 'Employee',
        };
        
        console.log('✅ User object created:', userObject);
        setCurrentUser(userObject);
        setLoading(false);
        
      } catch (err) {
        console.error('❌ Error parsing user from localStorage:', err);
        setError('Failed to load user data. Please login again.');
        setLoading(false);
      }
    };

    getUserFromLocalStorage();
  }, []);

  console.log('📊 Current state:', { loading, error, currentUser });

  // Loading state
  if (loading) {
    console.log('⏳ Showing loading spinner...');
    return (
      <div style={{ 
        minHeight: '100vh', 
        backgroundColor: '#f5f5f5', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center' 
      }}>
        <Spin size="large" tip="Loading your performance data..." />
      </div>
    );
  }

  // Error state
  if (error) {
    console.log('⚠️ Showing error:', error);
    return (
      <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5', padding: 24 }}>
        <Card>
          <Alert
            message="Unable to Load Data"
            description={error}
            type="error"
            showIcon
          />
        </Card>
      </div>
    );
  }

  // Show user detail view without back button
  console.log('✅ Rendering UserRatingDetailView with user:', currentUser);
  return (
    <UserRatingDetailView 
      user={currentUser} 
      onBack={null}
    />
  );
};

export default UserRatingPage;